import { flow, types } from 'mobx-state-tree';
import { OnboardingList } from 'components/tour/tour.types';
import { Onboardings } from 'http-requests';
import { TourRegistryKey } from 'components/tour/tour.registry';
import { RequestStateModel } from './general-models';

export const OnboardingStore = types
  .model('OnboardingStore', {
    onboardingData: types.optional(
      types.frozen<OnboardingList>(),
      {} as OnboardingList
    ),
  })
  .volatile(() => ({
    getOnboardingInfoStatus: RequestStateModel.create(),
    patchOnboardingInfoStatus: RequestStateModel.create(),
  }))
  .actions((self) => ({
    getOnboardingInfo: flow(function* (userId: string) {
      try {
        self.getOnboardingInfoStatus.loadingStates();

        const response: OnboardingList = yield Onboardings.GetOnboardingInfo();

        self.onboardingData = response;

        localStorage.setItem(userId, JSON.stringify(response));

        self.getOnboardingInfoStatus.successStates();

        return response;
      } catch (e) {
        console.error(e);
        self.getOnboardingInfoStatus.errorStates();
      } finally {
        self.getOnboardingInfoStatus.finallyStates();
      }
    }),
    patchOnboardingInfo: flow(function* (
      data: {
        block: TourRegistryKey;
        viewed: boolean;
        version: number;
      },
      userId: string
    ) {
      try {
        self.patchOnboardingInfoStatus.loadingStates();

        const response: OnboardingList =
          yield Onboardings.PatchOnboardingInfo(data);

        self.onboardingData = response;

        localStorage.setItem(userId, JSON.stringify(response));

        self.patchOnboardingInfoStatus.successStates();

        return response;
      } catch (e) {
        console.error(e);
        self.patchOnboardingInfoStatus.errorStates();
      } finally {
        self.patchOnboardingInfoStatus.finallyStates();
      }
    }),
  }));
